/**
Author - Babajan
Git - https://www.github.com/babajanpatan
**/

import React, {useState, useEffect} from "react";
import SafeLink from "components/commons/SafeLink";
import styled from "styled-components";

import {
  WealthyEnv
} from "helpers";

const ShareButtons = () => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  const faceBookShareLink = `${WealthyEnv.FACEBOOK_SHARE_LINK}=${url}?utm_source=Facebook&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;
  const twitterShareLink = `${WealthyEnv.TWITTER_SHARE_LINK}=${url}?utm_source=Twitter&utm_medium=Share&
  utm_campaign=New%20Blog%20Post&via=wealthy_india`;
  const linkedInShareLink = `${WealthyEnv.LINKEDIN_SHARE_LINK}=${url}?utm_source=LinkedIn&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;
  const whatsappShareLink = `${WealthyEnv.WHATSAPP_SHARE_LINK}?text=${url}?utm_source=WhatsApp&utm_medium=Share&
  utm_campaign=New%20Blog%20Post`;

  const faceBookIcon = `${WealthyEnv.GREY_MATTER_CDN_URL}/facebook.png`;
  const twitterIcon = `${WealthyEnv.CDN_URL}/articles/x-icon.png`;
  const linkedInIcon = `${WealthyEnv.CDN_URL}/articles/linkedin-share-buttons.png`;
  const whatsappIcon = `${WealthyEnv.CDN_URL}/articles/whatsapp-darkgreen-icon.png`;

  const iconArray = [
    {
      id: 1,
      shareLink: faceBookShareLink,
      alt: "facebook",
      icon: faceBookIcon
    },
    {
      id: 2,
      shareLink: twitterShareLink,
      alt: "twitter",
      icon: twitterIcon
    },
    {
      id: 3,
      shareLink: linkedInShareLink,
      alt: "linkedin",
      icon: linkedInIcon
    },
    {
      id: 4,
      shareLink: whatsappShareLink,
      alt: "whatsapp",
      icon: whatsappIcon
    }
  ];

  return (
    <SocialIcons>
      {
        iconArray.map((socialIcon) => (
          <SafeLink
            className="share-buttons__link"
            href={socialIcon.shareLink}
            key={socialIcon.id}
            rel="noopener noreferrer"
            target="_self"
          >
            <img
              alt={socialIcon.alt}
              className="share-buttons__image"
              loading="lazy"
              src={socialIcon.icon}
            />
          </SafeLink>
        ))
      }
    </SocialIcons>
  );
};

const SocialIcons = styled.div`
  position: -webkit-sticky;
  position: sticky;
  display: flex;
  left: 0;
  top: 20rem;
  margin-top: 20rem;
  margin-bottom: 6rem;
  grid-column: 1 / 3;
  flex-direction: column;
  align-items: center;
  height: 180px;

  .share-buttons__link {
    width: 5rem;
  }

  .share-buttons__image {
    width: 100%;
  }

  @media (max-width: 48em) {
    grid-column: 1 / 13;
    margin: 0;
    top: unset;
    height: auto;
    bottom: 5px;
    flex-direction: row;
    position: absolute;
    width: 100vw;
    justify-content: center;

    > *:not(:last-child) {
      margin-right: 1rem;
    }
  }
`;

export default ShareButtons;

